/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Settings_No_Assignment_ResultsInputs */

const en_task_settings_no_assignment_results = /** @type {(inputs: Task_Settings_No_Assignment_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matching assignment rules or people.`)
};

const pt_br2_task_settings_no_assignment_results = /** @type {(inputs: Task_Settings_No_Assignment_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma regra de atribuição ou pessoa encontrada.`)
};

/**
* | output |
* | --- |
* | "No matching assignment rules or people." |
*
* @param {Task_Settings_No_Assignment_ResultsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_settings_no_assignment_results = /** @type {((inputs?: Task_Settings_No_Assignment_ResultsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Settings_No_Assignment_ResultsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_settings_no_assignment_results(inputs)
	return pt_br2_task_settings_no_assignment_results(inputs)
});